"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

(function (window) {
  var AbstractBootstrapDropdown = /*#__PURE__*/function (_window$AbstractEleme) {
    _inherits(AbstractBootstrapDropdown, _window$AbstractEleme);

    var _super = _createSuper(AbstractBootstrapDropdown);

    _createClass(AbstractBootstrapDropdown, null, [{
      key: "SHOW_STATE",
      get: function get() {
        return "show.bs.dropdown";
      }
    }, {
      key: "SHOWN_STATE",
      get: function get() {
        return "shown.bs.dropdown";
      }
    }, {
      key: "HIDE_STATE",
      get: function get() {
        return "hide.bs.dropdown";
      }
    }, {
      key: "HIDDEN_STATE",
      get: function get() {
        return "hidden.bs.dropdown";
      }
    }]);

    function AbstractBootstrapDropdown(id, options) {
      var _this;

      _classCallCheck(this, AbstractBootstrapDropdown);

      var OPTIONS_DEFAULT = {
        dropdown: {
          offsetFn: function offsetFn(data) {
            data.left = 100;
            return data;
          },
          // Offset of the dropdown relative to its target. For more information refer to Popper.js's offset docs.
          flip: true //	Allow Dropdown to flip in case of an overlapping on the reference element. For more information refer to Popper.js's flip docs.

        }
      };
      options = $.extend(true, OPTIONS_DEFAULT, _.clone(options));
      _this = _super.call(this, id, options);
      _this.$toggleBtn = _this.$domElement.find(".dropdown-toggle"); //this.$toggleBtn.attr("data-toggle", "dropdown");

      _this.$menu = _this.$domElement.find(".dropdown-menu");
      _this.state = window.AbstractBootstrapDropdown.HIDDEN_STATE;

      _this.$toggleBtn.dropdown(_this.options.dropdown);

      _this.$menu.parent().on(window.AbstractBootstrapDropdown.SHOW_STATE, function (event) {
        _this.state = event.type;

        _this.dropdownShowHandler();
      });

      _this.$menu.parent().on(window.AbstractBootstrapDropdown.SHOWN_STATE, function (event) {
        _this.state = event.type;

        _this.dropdownShownHandler();
      });

      _this.$menu.parent().on(window.AbstractBootstrapDropdown.HIDE_STATE, function (event) {
        _this.state = event.type;

        _this.dropdownHideHandler();
      });

      _this.$menu.parent().on(window.AbstractBootstrapDropdown.HIDDEN_STATE, function (event) {
        _this.state = event.type;

        _this.dropdownHiddenHandler();
      });

      return _this;
    }

    _createClass(AbstractBootstrapDropdown, [{
      key: "dropdownShowHandler",
      value: function dropdownShowHandler() {
        var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        this.$menu.off("pointerenter").on("pointerenter", function (event) {
          Globals.bodyScrollEnabled = false;
        });
        this.$menu.off("pointerleave").on("pointerleave", function (event) {
          Globals.bodyScrollEnabled = true;
        });
      }
    }, {
      key: "dropdownShownHandler",
      value: function dropdownShownHandler() {//

        var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      }
    }, {
      key: "dropdownHideHandler",
      value: function dropdownHideHandler() {//

        var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      }
    }, {
      key: "dropdownHiddenHandler",
      value: function dropdownHiddenHandler() {
        var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        this.$menu.off("pointerenter");
        this.$menu.off("pointerleave");
      }
    }, {
      key: "toggle",
      value: function toggle() {
        this.$toggleBtn.dropdown("toggle");
      }
    }, {
      key: "update",
      value: function update() {
        this.$toggleBtn.dropdown("update");

        _get(_getPrototypeOf(AbstractBootstrapDropdown.prototype), "update", this);
      }
    }, {
      key: "dispose",
      value: function dispose() {
        this.$menu.parent().off("show.bs.dropdown shown.bs.dropdown hide.bs.dropdown hidden.bs.dropdown");
        this.$toggleBtn.dropdown("dispose");
        this.$toggleBtn = null;
        this.$menu.off("pointerenter pointerleave");
        this.$menu = null;
        this.state = null;
        Globals.bodyScrollEnabled = true;

        _get(_getPrototypeOf(AbstractBootstrapDropdown.prototype), "dispose", this).call(this);
      }
    }]);

    return AbstractBootstrapDropdown;
  }(window.AbstractElement);

  window.AbstractBootstrapDropdown = AbstractBootstrapDropdown;
})(window);
